import React from 'react';

const RadioS1 = ({ options, checked, onChange, radioItemClass = '', column }) => {
	return (
		<div className='row'>

			{options.map((option, i) => {
				const isChecked = option.value === checked;
				return (
					<div className={column ? `col-${column}` : "col-6"} key={i}>
						<div className={`radio-item ${isChecked ? '--checked' : ''} ${radioItemClass}`} onClick={() => onChange(option)}>
							<span className='radio-item-check'></span>
							<span>{option.label}</span>
						</div>
					</div>
				)
			})}

		</div>
	);
};

export default RadioS1;
